var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8352 25.2444L18.9919 17.4011C20.4795 15.5645 21.375 13.2297 21.375 10.6875C21.375 4.79446 16.5806 0 10.6875 0C4.79441 0 0 4.79446 0 10.6875C0 16.5806 4.79446 21.3751 10.6875 21.3751C13.2297 21.3751 15.5645 20.4795 17.4011 18.992L25.2444 26.8353C25.4642 27.0549 25.8202 27.0549 26.04 26.8353L26.8353 26.0399C27.0549 25.8202 27.0549 25.4641 26.8352 25.2444ZM10.6875 19.1251C6.03483 19.1251 2.25002 15.3402 2.25002 10.6875C2.25002 6.03483 6.03483 2.25002 10.6875 2.25002C15.3403 2.25002 19.1251 6.03483 19.1251 10.6875C19.1251 15.3402 15.3403 19.1251 10.6875 19.1251Z",
    fill: "#BFF736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.890b7bfdfef414d1ba530840a2154084.svg";
export { ForwardRef as ReactComponent };